import { getAssetPath } from "@stencil/core";
import {AbstractScrollBlocker} from "./abstractScrollBlocker";

/**
 * AbstractComponent
 */
export class AbstractComponent {
  /**
   * element
   */
  element: any;
  scrollBlocker: AbstractScrollBlocker;

  /**
   * getElement
   * @return Element
   */
  getElement() {
    return this.element;
  }

  /**
   * getContent
   * @return Element
   */
  getContent() {
    return this.element.shadowRoot || this.element;
  }

  /**
   * @return Document
   */
  getDocument() {
    return this.element.ownerDocument;
  }

  /**
   * getComponentAssetPath
   * @param additionalPath
   */
  getComponentAssetPath(additionalPath: string = "") {
    let componentName = this.element.tagName.toLowerCase().replace('dia-','');

    return getAssetPath('../../../../../../dist/collection/components/' + componentName + '/assets' + (additionalPath || "/"));
  }

  /**
   * getComponentAssetPath
   * @param additionalPath
   * @param componentName
   */
  static getComponentAssetPath(additionalPath: string = "", componentName: string) {
    let _componentName = componentName.toLowerCase().replace('dia-','');

    return getAssetPath('../../../../../../dist/collection/components/' + _componentName + '/assets' + (additionalPath || "/"));
  }

  /**
   * getScrollBlocker
   */
  getScrollBlocker() {
    if (this.scrollBlocker === undefined) {
      this.scrollBlocker = new AbstractScrollBlocker(this.element);
    }

    return this.scrollBlocker;
  }
}
